import { render, staticRenderFns } from "./DeliverySpaceCreate.vue?vue&type=template&id=3a694fa0&"
import script from "./DeliverySpaceCreate.vue?vue&type=script&lang=ts&"
export * from "./DeliverySpaceCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports